export default __webpack_public_path__ + "static/media/icon-table-engine.917dffaf.svg";